<template>
  <div class="section-container">
    <div class="main-container clearfix">
      <!--<person :counselor-info="counselorInfo" :skill-map="skillMap"/>-->

      <person :counselor-id="counselorId" :loan-type-arr="loanTypeArr"/>
      <div class="articles-wrap">
        <h2 data-v-ccf85fc8="" class="area-title"><span class="article-title">文章列表</span></h2>
        <typebar @on-item-click="onTypeChange" :loan-type-arr="loanTypeArr" :selected-index="selectedIndex"/>
        <div class="articles-list" ref="articleList">
          <datagrid
            @on-item-click="onItemClick"
            :articleList="articleList"/>
        </div>
        <Loading
          v-show="articleList.length === 0"
          :height="100"
          :is-no-more="articleListNoMore"/>
        <!-- <div class="message" ref="message" v-show="articleList && articleList.length === 0"></div> -->
        <div class="pagebar-box">
          <pagination
            :align="'right'"
            :count="count"
            :current-page="currentPage"
            :page-size="pageSize"
            @on-page-click="onPageClick"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Typebar from '@/components/combo/typebar'
  import Loading from '@/components/combo/loading'
  import Datagrid from '@/components/combo/datagrid'
  import Pagination from '@/components/combo/pagination'
  import Person from '@/components/consultant/person'
  const SHOWNUMBER = 3
  export default {
    data () {
      return {
        counselorInfo: {},
//        skillMap: [],
        loanTypeArr: [],
        loanTypeId: null,
        counselorId: null,
        articleList: [],
        count: 0,
        page: {},
        currentPage: 1,
        pageSize: 10,
        // copyRightMap: new Map(),
        showNumber: SHOWNUMBER,
        selectedIndex: null,
        articleListNoMore: false
      }
    },
    created () {
      this.counselorId = this.$route.params.uid
//      this.counselorId = 'CBFE82B16607452CBE63E631A89571ED'
      this.getLoanTypeArr()
      // this._getCopyRightTag()
    },
    watch: {
      '$store.state.city' () {
        this.$router.push(`/consultant/counserlor`)
      }
    },
    mounted () {
      this.onTypeChange()
    },
    methods: {
      getLoanTypeArr () {
        let vm = this
        this.$http({
          url: '/getLoanTypeMap.jhtml',
          data: {
            cityNo: this.$store.state.city.code
          },
          done (result) {
            vm.loanTypeArr = [].concat(result)
          }
        })
      },
      _fetchArticleListByLoanType () {
        this.articleListNoMore = false
        let vm = this
        this.$http({
          url: '/getMoreArticleByCounselor.jhtml',
          data: {
            counselorId: vm.counselorId,
            loanType: vm.loanTypeId,
            isPage: 'y',
            pageNumber: vm.currentPage || 1,
            pageSize: vm.pageSize
          },
          done (articles, page) {
            setTimeout(() => {
              vm.articleList = articles
              vm.page = page || {}
              vm.count = page.count
              if (vm.articleList.length === 0) {
                // vm.$refs.message.innerText = '暂无数据'
                vm.articleListNoMore = true
              }
            }, 200)
          }
        })
      },
      // _getCopyRightTag () {
      //   let vm = this
      //   this.$http({
      //     url: '/getLookupCdeList.jhtml',
      //     data: {
      //       typeCode: 20008005
      //     },
      //     done (result) {
      //       result.forEach(item => {
      //         vm.copyRightMap.set(item.cdeCode, item.cdeName)
      //       })
      //       vm.copyRightMap = Object.assign(new Map(), vm.copyRightMap)
      //     }
      //   })
      // },
      onTypeChange (index, item) {
        index !== null ? this.selectedIndex = index : this.selectedIndex = null
        this.currentPage = 1
        this.articleList = []
        item && (this.loanTypeId = item.id)
        // this.$refs.message.innerText = '正在加载中。。。'
        this._fetchArticleListByLoanType()
      },
      onPageClick (currentPage) {
        this.currentPage = currentPage
        this.articleList = []
        // this.$refs.message.innerText = '正在加载中。。。'
        this._fetchArticleListByLoanType()
//        document.documentElement.scrollTop = 0
//        document.body.scrollTop = 0
      },
      onItemClick (article) {
        window.open(`/consultant/article/${this.counselorId}?articleId=${article.id}`)
        // this.$router.push(`/consultant/article/${this.counselorId}?articleId=${article.id}`)
      }
    },
    components: {
      Typebar,
      Datagrid,
      Pagination,
      Person,
      Loading
    }
  }
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .main-container
    padding 44px 0 0 0
  .articles-wrap
    margin-top 38px
    .area-title
      border-left 6px solid rgb(82, 100, 211)
      font-size 18px
      padding-left 14px
      height 30px
      letter-spacing 6px
      line-height 30px
      margin 0
    .articles-list
      display table
      width 100%
      border-collapse collapse
      border-spacing 0
      table-layout fixed
      .datagrid
        display table-cell
        width 50%
        &.bordered
          border-left 3px dotted #1a4369
    .more, .more:active, .more:hover
      margin 10px 0 21px
      font-size 12px
      color #4de1ff
      text-decoration underline
  .pagebar-box
    margin 46px 0 100px
</style>



// WEBPACK FOOTER //
// consultant-articles.vue?27726a04